/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".backdrop[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.6);position:fixed;top:0;left:0;width:100%;height:100vh;z-index:99}"];
export { styles as styles };

